import React from 'react';
import { useAuth } from '../context/AuthContext';
import { RegionTestComponent } from './RegionTestComponent';

export const DebugDataView: React.FC = () => {
  const { 
    marketingCampaigns, 
    partnerCampaigns, 
    advertisements, 
    partners,
    loading 
  } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="space-y-8 max-w-6xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold mb-4">Debug Data View</h2>
        
        {/* Region Test Component */}
        <div className="mb-8">
          <RegionTestComponent />
        </div>
        
        <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold mb-2">Marketing Campaigns ({marketingCampaigns.length})</h3>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto max-h-40">
            {JSON.stringify(marketingCampaigns, null, 2)}
          </pre>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-2">Partner Campaigns ({partnerCampaigns.length})</h3>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto max-h-40">
            {JSON.stringify(partnerCampaigns, null, 2)}
          </pre>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-2">Advertisements ({advertisements.length})</h3>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto max-h-40">
            {JSON.stringify(advertisements, null, 2)}
          </pre>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-2">Partners ({partners.length})</h3>
          <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto max-h-40">
            {JSON.stringify(partners, null, 2)}
          </pre>
        </div>
      </div>
      </div>
    </div>
  );
};
